import React, { useMemo } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Testimonials from "../component/Testimonials";
import AboutBanner from "../component/AboutBanner";
import AboutBox from "../component/AboutBox";
import AboutMakingHome from "../component/AboutMakingHome";
import { usePageContent } from "../hooks/usePageContent";
import { ASSETS_URL } from "../api/constants";
import { Helmet } from "react-helmet-async";
function AboutUs() {
  const { content } = usePageContent("about-us");

  const aboutSection = useMemo(() => {
    if (!content?.about_us_section) return null;

    if (typeof content.about_us_section === "string") {
      try {
        return JSON.parse(content.about_us_section);
      } catch (err) {
        console.error("Failed to parse about_us_section JSON:", err);
        return null;
      }
    }

    return content.about_us_section;
  }, [content]);

  const section1 = aboutSection?.section_1;
  const section2 = aboutSection?.section_2;
  const section3 = aboutSection?.section_3;
  const section4 = aboutSection?.section_4;

  const bannerImage = content?.main_banner_image
    ? `${ASSETS_URL}${content.main_banner_image}`
    : undefined;

  return (
    <>
      <Helmet>
        <title>About Us | Jambobay</title>
        <meta
          name="description"
          content="Learn more about Jambobay, our mission, values, and the team behind our success."
        />
        <meta
          name="keywords"
          content="About Us, Jambobay, Company, Team, Mission, Values"
        />
      </Helmet>
      <div className="main about-us-page">
        <Header />
        <AboutBanner section={section1} imageUrl={bannerImage} />
        <AboutMakingHome section={section2} />
        <AboutBox section3={section3} section4={section4} />
        <Testimonials />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default AboutUs;
